import type { FC } from "react"
import { IconChevronRightOutline18 as ChevronRight } from "nucleo-ui-outline-18"

const CustomChevron: FC<{
	className?: string
	width?: number
	height?: number
	strokeWidth?: number
}> = ({ className, width = 12, height = 12, strokeWidth = 1.75 }) => (
	<ChevronRight
		width={width}
		height={height}
		className={className}
		strokeWidth={strokeWidth}
	/>
)

export default CustomChevron
